import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const informationLinks = [
    { path: '/services', label: 'Solar Solutions' },
    { path: '/about', label: 'About Us' },
    { path: '/contact', label: 'Get a Quote' },
    { path: '/gallery', label: 'Our Projects' },
    { path: '/blog', label: 'Solar Blog' }
  ];

  const solarServices = [
    { path: '/services', label: 'Residential Solar' },
    { path: '/services', label: 'Commercial Solar' },
    { path: '/services', label: 'Solar Maintenance' },
    { path: '/services', label: 'Energy Storage' },
    { path: '/services', label: 'Solar Financing' }
  ];

  return (
    <footer className="footer-corporate">
      <div className="footer-container">
        {/* Single Row Footer Layout */}
        <div className="footer-columns-row">
          {/* Column 1: Logo + About Text + Social Media */}
          <div className="footer-column-1">
            <div className="footer-logo-container">
              <img
                src="/images/global-solar-logo-new.png"
                alt="Global Solar Energy Logo"
                className="footer-logo"
              />
            </div>
            <div className="footer-about-text">
              <p>Global Solar Energy delivers end-to-end solar solutions, from site assessment and system design to installation, maintenance, and financing for both residential and commercial projects.</p>
            </div>
          </div>

          {/* Column 2: Information Links */}
          <div className="footer-column-2">
            <h4>Information</h4>
            <div className="footer-links-vertical">
              {informationLinks.map((link, index) => (
                <Link key={index} to={link.path}>{link.label}</Link>
              ))}
            </div>
          </div>

          {/* Column 3: Solar Services Links */}
          <div className="footer-column-3">
            <h4>Solar Services</h4>
            <div className="footer-links-vertical">
              {solarServices.map((service, index) => (
                <Link key={index} to={service.path}>{service.label}</Link>
              ))}
            </div>
          </div>

          {/* Mobile Row 1: Information and Solar Services side by side (duplicated for mobile) */}
          <div className="footer-mobile-row-1">
            {/* Column 2: Information Links */}
            <div className="footer-column-2">
              <h4>Information</h4>
              <div className="footer-links-vertical">
                {informationLinks.map((link, index) => (
                  <Link key={index} to={link.path}>{link.label}</Link>
                ))}
              </div>
            </div>

            {/* Column 3: Solar Services Links */}
            <div className="footer-column-3">
              <h4>Solar Services</h4>
              <div className="footer-links-vertical">
                {solarServices.map((service, index) => (
                  <Link key={index} to={service.path}>{service.label}</Link>
                ))}
              </div>
            </div>
          </div>

          {/* Column 4: Contact Details */}
          <div className="footer-column-4">
            <h4>Contact</h4>
            <div className="footer-contact-vertical">
              <span><i className="fas fa-phone"></i> +91 97248 20358</span>
              <span><i className="fas fa-envelope"></i> globalsolar99@gmail.com</span>
              <span><i className="fas fa-clock"></i> Mon-Sat, 10AM-7PM</span>
              <span><i className="fas fa-map-marker-alt"></i> S-5, Shivam Plaza Complex, Old Marketing Yard, Amreli-365601</span>
            </div>
          </div>

          {/* Column 5: Google Map */}
          <div className="footer-column-5">
            <div className="footer-map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.234567890123!2d70.12345678901234!3d21.12345678901234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjHCsDA3JzI0LjQiTiA3MMKwMDcnMjQuNCJF!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
                width="100%"
                height="180"
                style={{ border: 0, borderRadius: '8px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Global Solar Energy Location"
              ></iframe>
            </div>
            <a
              href="https://maps.app.goo.gl/R9RdghE9UM79qMXD9?g_st=iwb"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-map-link"
            >
              View Map
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-container">
          <p style={{ marginBottom: '10px' }}>
            &copy; {currentYear} Global Solar Energy. All rights reserved. |
            Developed by{' '}
            <a
              href="https://www.technocoders.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#22c55e',
                textDecoration: 'underline',
                fontWeight: '500',
                cursor: 'pointer',
                fontSize: 'inherit',
                fontFamily: 'inherit',
                position: 'relative',
                zIndex: '99999',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#3b82f6'}
              onMouseLeave={(e) => e.target.style.color = '#22c55e'}
            >
              Technocoders
            </a>
          </p>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        className="back-to-top-fab"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Back to top"
      >
        <i className="fas fa-chevron-up"></i>
      </button>
    </footer>
  );
};

export default Footer;